import { render, staticRenderFns } from "./setPsw.vue?vue&type=template&id=7db610d8&scoped=true&"
import script from "./setPsw.vue?vue&type=script&lang=js&"
export * from "./setPsw.vue?vue&type=script&lang=js&"
import style0 from "./setPsw.vue?vue&type=style&index=0&id=7db610d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db610d8",
  null
  
)

export default component.exports